import React, { useEffect, useState } from "react";

export default function ComingSoon() {
  const calculateTimeLeft = () => {
    const launchDate = new Date("2025-09-31T00:00:00");
    const difference = launchDate - new Date();

    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="h-screen w-full bg-gray-100 flex items-center justify-center">
      <div className="text-center p-8 rounded-xl shadow-lg bg-white max-w-md w-full">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Coming Soon</h1>
        <p className="text-gray-600 mb-6">
          We're working hard to launch our new site. Stay tuned!
        </p>

        {timeLeft.days !== undefined ? (
          <div className="flex justify-center gap-4 mb-6">
            {Object.entries(timeLeft).map(([unit, value]) => (
              <div key={unit} className="text-center">
                <div className="text-2xl font-bold text-blue-600">{value}</div>
                <div className="text-xs uppercase text-gray-500">{unit}</div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-green-600">We are live!</p>
        )}

        <form className="flex flex-col gap-3">
          <input
            type="email"
            placeholder="Enter your email"
            className="px-4 py-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300"
          />
          <button
            type="submit"
            className="bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition"
          >
            Notify Me
          </button>
        </form>

        <p className="text-xs text-gray-400 mt-6">© {new Date().getFullYear()} St. Joseph Royals</p>
      </div>
    </div>
  );
}